import React, { useEffect } from "react";
import PropTypes from 'prop-types';
import '../../styles/tabs.css'
import { Separator } from "../Headers/Separator";
import { Cita1 } from "../Citas/Cita1";
// import { PUBLIS } from "../../Json/PUBLIS";
import SectionTesis from "./SectionTesis";

const Patentes = (props) =>{
    return(
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <ol className="list-group list-group-numbered lista-patentes">
                        {
                            props.patents.map((patent, idx) => (
                                    <li key={idx} className="list-group-item d-flex justify-content-between align-items-start item-patente">
                                        <div className="ms-2 me-auto">
                                            {
                                                ( !patent.url )
                                                ?
                                                    patent.title
                                                :
                                                    <a href={patent.url}>{patent.title}</a>
                                            }
                                        </div>
                                        <span className="badge bg-primary rounded-pill">{patent.year}</span>
                                    </li>
                                )
                            )
                        }
                    </ol>
                </div>
            </div>
        </div>
    )
}

export const Publicaciones = (props)=>{
    useEffect(()=>{
        const btn_publicaciones = document.querySelectorAll('.btn-paper')
            btn_publicaciones.forEach((btn)=>{
                btn.addEventListener('click', ()=>{
                    let variale = btn.getAttribute("target")
                    let target = document.querySelector(`#${variale}`)
                    target.scrollIntoView({block: "center", behavior: "smooth"})
                })
            })
    },[])
    return(
        [
            ( props.papers && props.papers.years && props.papers.years.length > 0 ) 
            ?
                <section id="Publicaciones" key="Publicaciones" className="section">
                    <Separator name='Publicaciones'></Separator>
                    <Cita1 autor={'Joan-Baptista van Helmont, 1648'} cita={'Que todas las plantas derivan inmediata y sustancialmente del elemento acuático es lo que he aprendido del siguiente experimento. Tomé una vasija de barro en la cual coloqué 200 libras de tierra secada en un horno y regada con agua de lluvia. Planté allí el vástago de un sauce que pesaba cinco libras. Cinco años después se había convertido en un árbol que pesaba 169 libras y unas tres onzas. No se añadió nada más que lluvia (o agua destilada). Se colocó la gran vasija en tierra y fue cubierta con una tapadera de hierro recubierto de hojalata, que estaba perforada con varios orificios. No he pesado las hojas que cayeron en los cuatro otoños transcurridos. Finalmente, sequé la tierra en la vasija nuevamente y me encontré con las mismas 200 libras menos dos onzas. Por lo tanto, 164 libras de madera, corteza y raíces habían surgido exclusivamente del agua.'}></Cita1>
          
                    <div className="container">
                        <div className="row">
                            <div className="col-md-2 d-flex flex-column container-years">
                                {props.papers.years.map((year)=>{
                                    return(
                                        <p className="btn btn-paper m-2" target={`publicacion-${year}`} id={`publicacion-btn-${year}`} key={year}> {year}</p>
                                    )
                                })}
                            </div>
                           
                            <div className="col-md-10">                    
                            <div id="container-publicaciones" className="container-publicaciones" >
                                    {
                                        props.papers.years.map((year)=>{
                                            return (
                                                <div key={`publicacion-${year}`}>
                                                    <section id={`publicacion-${year}`}>
                                                        <h4 className="h3 header-paper my-2">{year}</h4>            
                                                        {
                                                            props.papers.byYear[year].map((paper, idx) =>{
                                                                return(
                                                                    <div key={idx}>
                                                                        <a className="paper-text" href={paper.url} target='_blank' rel='noreferrer'>{idx+1}.- {paper.title}</a>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </section>
                                                </div>
                                            ); 
                                        })
                                    }
                                </div> 
                            </div>
                        </div>
                    </div>
                </section>
            :
                null
        ,
            ( props.patents && props.patents.length > 0 )
                ?
                    <section id="patentes" key="patentes">
                        <Separator name='Patentes' key="1"></Separator>,
                        <div className="container">
                            <div className="row">
                                <Patentes {...props} key="2"/>
                            </div>
                        </div>
                    </section>
                :
                    null
        ,
            ( props.tesisTypes && props.tesisTypes.length > 0 && props.tesisCategories && props.tesisCategories.length > 0 )
            ?
                <section id="tesis" key="tesis">
                    <Separator name='Tesis' key='1'></Separator>,
                    <div className="container">
                        <div className="row">
                            <SectionTesis {...props} key='2'/>
                        </div>
                    </div>
                </section>
            :
                null
        ]
    )
}

Publicaciones.propTypes = {
    papers: PropTypes.shape({
        years: PropTypes.arrayOf(PropTypes.string),
        byYear: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.shape({
            title: PropTypes.string.isRequired,
            url: PropTypes.string,
            year: PropTypes.string,
        }))),
    }),
    patents: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        url: PropTypes.string,
        year: PropTypes.string,
    })),
    tesisTypes: PropTypes.array,
    tesisCategories: PropTypes.array,
    tesis: PropTypes.object,
};